// utils/homeRoute.js
//
// Single source of truth for "where does this person's hub live".
// Used by every dashboard's "Back to Hub" button instead of each one
// hardcoding its own literal path — see TeamDashboard.jsx's old
// navigate('/dashboard') bug, which sent every role to the Owner's hub.

export const getHomeRouteForRole = (role) => {
  const normalized = (role || '').toUpperCase();
  if (normalized === 'ACCOUNT_OWNER') return '/dashboard';
  if (normalized === 'ACCOUNT_MANAGER') return '/manager_dashboard';
  if (normalized === 'ACCOUNT_USER') return '/user-portal';
  // IMPORTANT: role can legitimately be empty for a brief moment while
  // AuthContext is still hydrating from localStorage on first render —
  // this is not the same as "role is genuinely unknown forever". The
  // fallback must NOT be '/dashboard' (Owner's hub): on a render where
  // role hasn't resolved yet, defaulting to the most-privileged
  // destination silently routes every role into the Owner's hub the
  // moment this runs before user data is ready. '/login' is always a
  // safe landing — at worst it bounces someone who is in fact already
  // authenticated, which self-corrects on the next render once role
  // is available, rather than leaking them into the wrong hub.
  return '/login';
};